export const getUniqueGradeBodyTypeId = (gradeId: string, bodyTypeId?: string, subModelId?: string): string =>
    `${subModelId || ""}${bodyTypeId || ""}${gradeId}`;
